import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4 rounded-lg bg-gradient-to-b from-gray-50 dark:from-gray-900 to-gray-100 dark:to-gray-850" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h6", null, "Terms and Agreement", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "text-sm",
  style: {"font-weight":"300 !important"}
}, [
  /*#__PURE__*/_createTextVNode(" By connecting the wallet to the Wavelength App, I agree to the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-green-943",
    href: "https://pdfhost.io/v/6nXpANnrp_Wavelength_Terms_of_Service",
    target: "_blank"
  }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(" and "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-green-943",
    target: "_blank",
    href: "https://pdfhost.io/v/Gbwje17oo_Wavelength_Risk_Disclosure_Statement"
  }, "Risk Disclosure Statement"),
  /*#__PURE__*/_createTextVNode(", and acknowledge the "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-green-943",
    target: "_blank",
    href: "https://pdfhost.io/v/OGp3wZXDi_Wavelength_Privacy_Notice"
  }, "Privacy Notice"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_4 = { class: "p-4 rounded-lg bg-gradient-to-b from-gray-50 dark:from-gray-900 to-gray-100 dark:to-gray-850" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "New to Velas?", -1)
const _hoisted_6 = {
  class: "text-sm",
  style: {"font-weight":"300 !important"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Wavelength is a DeFi app on Velas Chain. To invest and trade here, you'll first need to set up an Velas compatible wallet. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Learn More ")
const _hoisted_9 = { class: "align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WalletButton = _resolveComponent("WalletButton")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalLink = _resolveComponent("BalLink")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: _ctx.isVisible,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    title: "Connect to a wallet"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["", _ctx.counter ? '' : 'hidden'])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wallets, (wallet) => {
          return (_openBlock(), _createBlock(_component_WalletButton, {
            wallet: wallet,
            key: wallet
          }, null, 8, ["wallet"]))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_BalBtn, { onClick: _ctx.modify }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.name), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_BalLink, {
            href: _ctx.EXTERNAL_LINKS.Ethereum.Wallets,
            external: ""
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_BalIcon, {
                  name: "arrow-up-right",
                  size: "sm"
                })
              ])
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}